// src/components/Team.jsx
import React, { useState } from "react";
import { TeamModal } from "./teammodal";

export const Team = (props) => {
  const members = props.data || [];
  const [activeIndex, setActiveIndex] = useState(null);
  const active = activeIndex !== null ? members[activeIndex] : null;

  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Conheça a nossa equipa</h2>
          <p>
            Profissionais qualificados e dedicados ao seu bem-estar, com
            formação académica sólida e prática clínica comprovada.
          </p>
        </div>

        <div id="row">
          {members.length
            ? members.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4 col-md-12 team">
                  <div
                    className="thumbnail team-card"
                    role="button"
                    tabIndex={0}
                    onClick={() => setActiveIndex(i)}
                    onKeyDown={(e) => e.key === "Enter" && setActiveIndex(i)}
                    title="Ver perfil"
                  >
                    <div className="team-card__imgwrap">
                      <img src={d.img} alt={d.name} className="team-img" />
                      <div className="team-card__overlay" aria-hidden="true" />
                    </div>
                    <div className="caption team-card__caption">
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>

      <TeamModal
        isOpen={activeIndex !== null}
        onClose={() => setActiveIndex(null)}
        member={active}
      />
    </div>
  );
};
